import React, { createContext, useState, useContext, useEffect } from "react";

interface AuthContextType {
  isAuthenticated: boolean;
  login: () => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

const isTokenValid = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const now = Date.now() / 1000;

    return payload.exp > now;
  } catch {
    return false;
  }
};

export const AuthProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {

  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  // INIT
  useEffect(() => {
    setIsAuthenticated(isTokenValid());
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const token = localStorage.getItem("accessToken");

      if (!token) return;

      if (!isTokenValid()) {
        logout();
      }
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const login = () => {
    setIsAuthenticated(true);
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};